import { createFileRoute } from '@tanstack/react-router';
import { liveEventDetailsQuery } from '@/api/queries';
import { isLiveEventNotFoundError } from '@/live/live-event-finished';
import {
  LiveEventDetails,
  LiveEventDetailsSkeleton,
} from './-components/LiveEventDetails';

export type LiveEventIdLoaderData = {
  finished: boolean;
};

export const Route = createFileRoute('/live/$eventId')({
  loader: async ({ context, params }): Promise<LiveEventIdLoaderData> => {
    try {
      await context.queryClient.ensureQueryData(liveEventDetailsQuery(params.eventId));
      return { finished: false };
    } catch (error) {
      if (isLiveEventNotFoundError(error)) {
        return { finished: true };
      }
      throw error;
    }
  },
  pendingComponent: LiveEventDetailsSkeleton,
  component: LiveEventDetailsPage,
});

function LiveEventDetailsPage() {
  const { eventId } = Route.useParams();
  const { finished } = Route.useLoaderData();
  return <LiveEventDetails eventId={eventId} initiallyFinished={finished} />;
}
